/**
 * Sorts presets by display name using Czech locale rules (handles diacritics).
 *
 * @param {Object[]} presets
 * @returns {Object[]}
 */
export function sortPresetsByName(presets) {
  return [...presets].sort((left, right) => left.name.localeCompare(right.name, "cs"));
}
